import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from '@/app';
import PiwikPro from '@piwikpro/react-piwik-pro';
import { setPiwikCompliance, setPiwikInitialCompliance } from './utils/piwik-consent-helper';

PiwikPro.initialize('d94e6a0d-6a97-4ace-8725-433bd5e698e0', 'https://bestmatch.containers.piwik.pro/', {
    nonce: 'nonce-string',
    dataLayerName: 'dataLayer'
});

setPiwikInitialCompliance({
    analytics: { status: 1 }
});

setPiwikCompliance({
    analytics: { status: 1 }
});

// Which workflow and branding the API resolves is driven by the entry domain, and the
// dev server proxies /api (rewriting Host), so every request carries the browser's
// hostname. buildPostHeaders sets the same header on POSTs.
axios.defaults.headers.common['dash-domain'] = window.location.hostname;

// Bootstrap 3.3.7 ships bundled inside Content/nkr.css (loaded via <link> in
// index.html), so it is not imported separately here.
import './styles/global.css';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('dash-root');

if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
        // <React.StrictMode>
        <App />
        // </React.StrictMode>
    );
} else {
    console.error('DASH: Could not find root container element (#dash-root)');
}
